import { toInteger } from 'lodash';

export const formatMoney = (money: number | string): string => {
	const moneyInt = toInteger(money);
	return new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
	}).format(moneyInt);
};

export const formatToPercentage = (growth: number): string => {
	const sign = Math.sign(growth) > 0 ? '+' : '-';
	const absValue = Math.abs(growth);
	const rounded = absValue.toFixed(1);
	return `${sign}${rounded}%`;
};

export const segmentCaseWithNumbers = (eventText: string) => {
	const lowerCasedString = eventText.toLowerCase().trim();

	// If it's just a price, return as is
	if (/^\$\d{1,3}(,\d{3})*$/.test(lowerCasedString)) {
		return lowerCasedString;
	}

	// Split by spaces while preserving prices and percentages
	const words = lowerCasedString.split(' ');
	const formattedWords = words.map(word => {
		// Preserve prices and percentages
		if (/^\$\d{1,3}(,\d{3})*$/.test(word) || /^\d+%$/.test(word)) {
			return word;
		}
		// Clean other words
		return word.replace(/[&,'\\/\-:]/g, '');
	});

	// Join with underscores
	return formattedWords.join('_');
};
